import type { BoxProps } from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import type { FunctionComponent } from 'react';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

import { StarRating } from '../star_rating/StarRating';

interface TrustAndDownloadCardProps extends BoxProps {
  className?: string;
}

/**
 * Trust and download app Card
 */
const UnstyledTrustAndDownloadCard: FunctionComponent<TrustAndDownloadCardProps> = ({
  className,
  ...boxProps
}): JSX.Element => {
  return (
    <Box className={className} {...boxProps}>
      <Typography className="highlightColor">{'Trusted by 5+ million car owners'}</Typography>
      <Box mt={2} display={'flex'} justifyContent={'space-between'} alignContent={'baseline'}>
        <Box>
          <Typography className="fontWeight500">{'4.7/5'}</Typography>
          <Typography className="grayFontColor">{'22,183 reviews'}</Typography>
        </Box>
        <StarRating />
      </Box>
    </Box>
  );
};

export const TrustAndDownloadCard = styled(UnstyledTrustAndDownloadCard)`
  text-align: left;
  border-radius: 0.5rem;
  background-color: transparent;

  .highlightColor {
    font-family: Circular Std, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 1rem;
  }

  .grayFontColor {
    color: #6e7e91;
  }

  .fontWeight500 {
    font-weight: bold;
    font-size: 1.5rem;
  }
`;
